import { render, staticRenderFns } from "./add-vessel.vue?vue&type=template&id=24566d22"
import script from "./add-vessel.vue?vue&type=script&lang=js"
export * from "./add-vessel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports